import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { LegacyInputTextComponent, DropdownWithValidation } from '../../../../../components/prime-formik';

const i18n = defineMessages({
  title: {
    id: 'attrs.title',
    defaultMessage: 'Title',
  },
});

export const General = ({ editing }) => {
  const { formatMessage } = useIntl();
  const titlePlaceholder = formatMessage(i18n.title);

  return (
    <div className="p-grid p-fluid">
      <div className="form-group p-col-12" key="title">
        <FormattedMessage
          tagName="label"
          htmlFor="title"
          className="field-label"
          id="attrs.title"
          defaultMessage="Title"
        />
        <Field
          id="title"
          name="title"
          component={LegacyInputTextComponent}
          placeholder={titlePlaceholder}
          disabled={!editing}
        />
      </div>
    </div>
  );
};

General.propTypes = {
  editing: PropTypes.bool.isRequired,
};

export const EmailTemplates = (props) => {
  const { templates, editing } = props;
  const invites = templates.invites.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const thanks = templates.thanks.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const reminders = templates.reminders.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const feedbacks = templates.feedbacks.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12 p-nogutter">
        <h3 key="title">
          <FormattedMessage id="attrs.email_templates" defaultMessage="Email Templates" />
        </h3>
      </div>
      <div className="p-col-6 form-group email-template align-bottom" key="invite">
        <label className="field-label" htmlFor="inviteTemplateId">
          <FormattedMessage id="attrs.invite_email_template" defaultMessage="Invite Email Template" />
        </label>
        <Field
          id="invite"
          name="inviteTemplateId"
          component={DropdownWithValidation}
          options={invites}
          disabled={!editing}
        />
      </div>
      <div className="p-col-6 form-group email-template align-bottom" key="thank">
        <label className="field-label" htmlFor="thankYouTemplateId">
          <FormattedMessage id="attrs.thank_email_template" defaultMessage="Thank You Email Template" />
        </label>
        <Field
          id="thankyou"
          name="thankYouTemplateId"
          component={DropdownWithValidation}
          options={thanks}
          disabled={!editing}
        />
      </div>
      <div className="p-col-6 form-group email-template align-bottom" key="reminder">
        <label className="field-label" htmlFor="reminderTemplateId">
          <FormattedMessage id="attrs.reminder_email_template" defaultMessage="Reminder Email Template" />
        </label>
        <Field
          id="reminder"
          name="reminderTemplateId"
          component={DropdownWithValidation}
          options={reminders}
          disabled={!editing}
        />
      </div>
      <div className="p-col-6 form-group email-template align-bottom" key="feedback">
        <label className="field-label" htmlFor="feedbackTemplateId">
          <FormattedMessage id="attrs.feedback_email_template" defaultMessage="Feedback Email Template" />
        </label>
        <Field
          id="feedback"
          name="feedbackTemplateId"
          component={DropdownWithValidation}
          options={feedbacks}
          disabled={!editing}
        />
      </div>
    </div>
  );
};

EmailTemplates.propTypes = {
  editing: PropTypes.bool.isRequired,
  templates: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default EmailTemplates;
